import { z } from "zod";

import { OfferWithIdSchema } from "../../../../dtos/offers";

import { PluginOfferProductSchema } from "./offerProducts";

export const PluginOfferSchema_2024_05_05 = OfferWithIdSchema.omit({
  discountApp: true,
});

export type PluginOfferType_2024_05_05 = z.infer<
  typeof PluginOfferSchema_2024_05_05
>;
